(function () {
  function getPacking(sectionId) {
    return document.querySelector('[data-bm7-packing][data-section-id="' + sectionId + '"]');
  }

  function isWithPremiumBox(packing) {
    return !!(packing && packing.querySelector('[data-packing-value="with"].is-active'));
  }

  function getPremiumVariantId(packing) {
    if (!packing) return '';
    return packing.getAttribute('data-premium-box-variant-id') || '';
  }

  function getSectionIdFromForm(form) {
    var productForm = form.closest('product-form');
    return productForm ? productForm.dataset.sectionId : '';
  }

  function getProductForm(form) {
    return form.closest('product-form');
  }

  function getCartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function buildCartItems(form, packing) {
    var fd = new FormData(form);
    var mainId = parseInt(fd.get('id'), 10);
    var qty = parseInt(fd.get('quantity') || '1', 10) || 1;
    var premiumId = parseInt(getPremiumVariantId(packing), 10);
    var productTitle = packing.getAttribute('data-product-title') || '';

    var items = [
      {
        id: mainId,
        quantity: qty,
        properties: {
          Box: 'Yes (+Rs 400)',
        },
      },
    ];

    if (premiumId) {
      items.push({
        id: premiumId,
        quantity: qty,
        properties: productTitle ? { '_For fabric': productTitle } : {},
      });
    }

    return items;
  }

  function setSubmitLoading(productForm, loading) {
    if (!productForm) return;
    var submitButton = productForm.querySelector('[type="submit"]');
    var spinner = productForm.querySelector('.loading__spinner');
    if (!submitButton) return;

    if (loading) {
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');
    } else {
      submitButton.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
      if (productForm.dataset.bm7AddError !== '1') {
        submitButton.removeAttribute('aria-disabled');
      }
    }
  }

  function showFormError(productForm, message) {
    if (!productForm || productForm.dataset.hideErrors === 'true') return;
    var wrapper =
      productForm.querySelector('.product-form__error-message-wrapper') ||
      productForm.querySelector('.product-form__error-message-wrapper');
    var errorMessage = productForm.querySelector('.product-form__error-message');
    if (!wrapper || !errorMessage) return;
    wrapper.toggleAttribute('hidden', !message);
    if (message) errorMessage.textContent = message;
  }

  function renderCartResponse(productForm, response) {
    var cart = getCartElement();
    if (!cart) {
      window.location = window.routes.cart_url;
      return;
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        productVariantId: String(response.items && response.items[0] ? response.items[0].variant_id : ''),
        cartData: response,
      });
    }

    var quickAddModal = productForm.closest('quick-add-modal');
    if (quickAddModal) {
      document.body.addEventListener(
        'modalClosed',
        function () {
          setTimeout(function () {
            cart.renderContents(response);
          });
        },
        { once: true }
      );
      quickAddModal.hide(true);
    } else {
      cart.renderContents(response);
    }

    if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
  }

  function addPremiumBoxToCart(form, packing, productForm) {
    var premiumId = getPremiumVariantId(packing);
    if (!premiumId) {
      showFormError(
        productForm,
        'Box is not available right now. Please choose Without Box or contact us.'
      );
      return Promise.resolve({ error: true });
    }

    setSubmitLoading(productForm, true);
    showFormError(productForm, false);
    productForm.dataset.bm7AddError = '0';

    var items = buildCartItems(form, packing);
    var cart = getCartElement();

    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (response) {
        if (response.status) {
          productForm.dataset.bm7AddError = '1';
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: new FormData(form).get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          showFormError(productForm, response.description || response.message || 'Could not add to cart.');
          return response;
        }

        if (!cart) {
          window.location = window.routes.cart_url;
          return response;
        }

        var sectionIds = cart
          .getSectionsToRender()
          .map(function (section) {
            return section.id;
          })
          .join(',');

        return fetch(window.routes.cart_url + '?sections=' + sectionIds)
          .then(function (res) {
            return res.json();
          })
          .then(function (sections) {
            response.sections = sections;
            renderCartResponse(productForm, response);
            return response;
          });
      })
      .catch(function (err) {
        console.error(err);
        productForm.dataset.bm7AddError = '1';
        showFormError(productForm, 'Could not add to cart. Please try again.');
      })
      .finally(function () {
        setSubmitLoading(productForm, false);
      });
  }

  function buyNowWithPremiumBox(form, packing, button) {
    var premiumId = getPremiumVariantId(packing);
    if (!premiumId) {
      window.alert('Box is not available right now. Please choose Without Box or contact us.');
      return;
    }

    var items = buildCartItems(form, packing);
    button.disabled = true;
    button.classList.add('loading');

    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () {
        return fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        });
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || response.message || 'Could not start checkout.');
        }
        window.location = '/checkout';
      })
      .catch(function (err) {
        console.error(err);
        window.alert(err.message || 'Could not start checkout. Please try again.');
        button.disabled = false;
        button.classList.remove('loading');
      });
  }

  function ensureBuyNowButton(sectionId) {
    var checkoutWrap = document.getElementById('DynamicCheckout-' + sectionId);
    if (!checkoutWrap || checkoutWrap.querySelector('[data-bm7-buy-now]')) return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className =
      'bm7-packing__buy-now shopify-payment-button__button shopify-payment-button__button--unbranded';
    button.hidden = true;
    button.dataset.bm7BuyNow = '';
    button.textContent = 'Buy it now';
    checkoutWrap.appendChild(button);

    button.addEventListener('click', function () {
      var productForm = checkoutWrap.closest('product-form');
      var form = productForm ? productForm.querySelector('form') : null;
      var packing = getPacking(sectionId);
      if (!form || !packing || !isWithPremiumBox(packing)) return;
      buyNowWithPremiumBox(form, packing, button);
    });
  }

  function syncBuyNowMode(sectionId) {
    var packing = getPacking(sectionId);
    var productForm = document.querySelector('product-form[data-section-id="' + sectionId + '"]');
    if (!packing || !productForm) return;

    ensureBuyNowButton(sectionId);

    var withPremium = isWithPremiumBox(packing) && !!getPremiumVariantId(packing);
    productForm.classList.toggle('bm7-premium-box-active', withPremium);

    var customBuyNow = document.querySelector('#DynamicCheckout-' + sectionId + ' [data-bm7-buy-now]');
    if (customBuyNow) customBuyNow.hidden = !withPremium;
  }

  function bindPackingCheckout(sectionId) {
    var packing = getPacking(sectionId);
    if (!packing || packing.dataset.bm7CheckoutBound) return;
    packing.dataset.bm7CheckoutBound = '1';

    packing.querySelectorAll('[data-packing-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        requestAnimationFrame(function () {
          syncBuyNowMode(sectionId);
        });
      });
    });

    syncBuyNowMode(sectionId);
  }

  function onFormSubmit(event) {
    var form = event.target;
    if (!form.matches('form[data-type="add-to-cart-form"]')) return;

    var sectionId = getSectionIdFromForm(form);
    var packing = getPacking(sectionId);
    if (!packing || !isWithPremiumBox(packing)) return;

    var productForm = getProductForm(form);
    if (!productForm) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addPremiumBoxToCart(form, packing, productForm);
  }

  function initSection(sectionId) {
    bindPackingCheckout(sectionId);
  }

  function initAll() {
    document.addEventListener('submit', onFormSubmit, true);
    document.querySelectorAll('[data-bm7-packing]').forEach(function (packing) {
      var sectionId = packing.getAttribute('data-section-id');
      if (sectionId) initSection(sectionId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.bm7SyncPremiumBoxCheckout = syncBuyNowMode;
})();
